<template>
  <!-- <v-layout class="fill-height" tag="v-list" column> -->
  <v-layout column>
    <v-navigation-drawer v-model="changesBilling" fixed right light width="400">
      <v-flex class="pl-2 pt-1" style="height: 100vh" v-if="loading">
        <v-icon @click.stop="changesBilling = false">close</v-icon>
        <v-layout align-center justify-center row fill-height>
          <v-progress-circular
            indeterminate
            color="#c0c0c0"
          ></v-progress-circular>
        </v-layout>
      </v-flex>
      <v-flex class="pl-2 pt-1" v-else>
        <!-- <v-flex class="pl-2 pt-1"> -->
        <v-icon @click.stop="changesBilling = false">close</v-icon>
        <v-list-tile>
          <v-flex sm12 md12 xs12>
            <v-subheader class="font-weight-bold" v-if="billing"
              >Histórico</v-subheader
            >
          </v-flex>
          <!-- <v-flex sm6 md6 xs6>
            <div class="detail-status detail-status--paid">{{billing.status}}</div>
            </v-flex> -->
          <!-- <v-img :src="logo" height="54" width="100%" /> -->
        </v-list-tile>
        <v-divider />
        <v-container>
          <p class="font-weight-black">
            {{ billing.user ? billing.user.name : "" }}
          </p>
          <p class="font-weight-medium">
            Competência: {{ billing ? billing.competence : "" }}
          </p>
          <p class="font-weight-medium">
            UC: {{ billing ? billing.consumer_unit : "" }}
          </p>
          <p class="font-weight-medium">
            Planta: {{ billing ? billing.power_plant_id : "" }}
          </p>
        </v-container>
        <v-card>
          <v-list dark>
            <v-list-group
              v-for="(item, i) in billing.changes"
              :key="i"
              v-model="item.active"
              no-action
            >
              <template v-slot:activator>
                <v-list-tile class="ma-3">
                  <v-list-tile-content>
                    <v-list-tile-sub-title>{{
                      item.user_email
                    }}</v-list-tile-sub-title>
                    <v-list-tile-title>{{
                      item.updated_at | formatarDateTime
                    }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>

              <v-card color="white" dark>
                <v-list dark>
                  <v-container
                    ><p v-if="item.change_description">
                      Descrição: {{ item.change_description }}
                    </p></v-container
                  >
                  <!-- <v-list-tile
                        avatar
                        class="v-list-item"
                        dark
                    >
                        <v-list-tile-action>
                            <v-icon class="grey--text">person</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-sub-title>Recalculado por</v-list-tile-sub-title>
                            <v-list-tile-title v-text="item.user_email" />
                        </v-list-tile-content>
                    </v-list-tile> -->

                  <v-list-tile
                    avatar
                    class="v-list-item"
                    v-if="
                      item.old_values &&
                      item.old_values.payment_type !== billing.payment_type
                    "
                  >
                    <v-list-tile-action>
                      <v-icon class="grey--text">{{
                        item.old_values.payment_type | paymentTypeIcon
                      }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content v-if="item.old_values.due_date">
                      <v-list-tile-sub-title>Vencimento</v-list-tile-sub-title>
                      <v-list-tile-title
                        >{{ item.old_values.due_date }} ->
                        {{ billing.due_date }}</v-list-tile-title
                      >
                    </v-list-tile-content>
                    <v-list-tile-content v-else>
                      <v-list-tile-sub-title
                        >Método de Pagamento</v-list-tile-sub-title
                      >
                      <v-list-tile-title
                        >{{ item.old_values.payment_type }} ->
                        {{ billing.payment_type }}</v-list-tile-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile
                    avatar
                    class="v-list-item"
                    v-if="
                      item.old_values &&
                      item.old_values.amount_kW !== billing.amount_kW
                    "
                  >
                    <v-list-tile-action>
                      <v-icon class="grey--text">offline_bolt</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-sub-title
                        >Créditos kWh</v-list-tile-sub-title
                      >
                      <v-list-tile-title
                        >{{ item.old_values.amount_kW }} ->
                        {{ billing.amount_kW }}</v-list-tile-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                  <!-- Valor kWh -->
                  <v-list-tile
                    avatar
                    class="v-list-item"
                    v-if="
                      item.old_values &&
                      item.old_values.energy_kWh_value !==
                        billing.energy_kWh_value
                    "
                  >
                    <v-list-tile-action>
                      <v-icon class="grey--text">power_input</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-sub-title
                        >Valor kWh R$</v-list-tile-sub-title
                      >
                      <v-list-tile-title
                        >R$
                        {{
                          item.old_values.energy_kWh_value | formatKWCurrency
                        }}
                        -> R$
                        {{
                          billing.energy_kWh_value | formatKWCurrency
                        }}</v-list-tile-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                  <!-- Economia -->
                  <v-list-tile
                    avatar
                    class="v-list-item"
                    v-if="
                      item.old_values &&
                      item.old_values.discount &&
                      item.old_values.discount !== billing.discount
                    "
                  >
                    <v-list-tile-action>
                      <v-icon class="success--text">stars</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-sub-title>Economia</v-list-tile-sub-title>
                      <v-list-tile-title
                        >R$ {{ item.old_values.discount | formatCurrency }} ->
                        R$
                        {{
                          billing.discount | formatCurrency
                        }}</v-list-tile-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile
                    avatar
                    class="v-list-item"
                    v-if="
                      item.old_values &&
                      item.old_values.account_balance &&
                      item.old_values.account_balance !==
                        billing.account_balance
                    "
                  >
                    <v-list-tile-action>
                      <v-icon class="green--text">star</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-sub-title>Bonus (R$)</v-list-tile-sub-title>
                      <v-list-tile-title
                        >R$
                        {{
                          Number(item.old_values.account_balance)
                            | formatCurrency
                        }}
                        -> R$
                        {{
                          Number(billing.account_balance) | formatCurrency
                        }}</v-list-tile-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider pb-3 />
                  <v-list-tile
                    avatar
                    class="v-list-item"
                    v-if="
                      item.old_values &&
                      item.old_values.total &&
                      item.old_values.total !== billing.total
                    "
                  >
                    <v-list-tile-action>
                      <v-icon class="green--text">star</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-sub-title>Total</v-list-tile-sub-title>
                      <v-list-tile-title
                        >R$
                        {{ Number(item.old_values.total) | formatCurrency }} ->
                        R$
                        {{
                          Number(billing.total) | formatCurrency
                        }}</v-list-tile-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider pb-3 />
                </v-list>
              </v-card>
            </v-list-group>
          </v-list>
        </v-card>
      </v-flex>
    </v-navigation-drawer>
  </v-layout>
</template>
<script>
import { eventBus } from "../../main";
export default {
  data: () => ({
    // logo: "../../img/logo_enercred_branco.png",
    changesBilling: false,
    billing: null,
    loading: true,
    items: [
      {
        action: "local_activity",
        title: "Attractions",
        items: [{ title: "List Item" }],
      },
      {
        action: "restaurant",
        title: "Dining",
        active: true,
        items: [
          { title: "Breakfast & brunch" },
          { title: "New American" },
          { title: "Sushi" },
        ],
      },
      {
        action: "school",
        title: "Education",
        items: [{ title: "List Item" }],
      },
      {
        action: "directions_run",
        title: "Family",
        items: [{ title: "List Item" }],
      },
      {
        action: "healing",
        title: "Health",
        items: [{ title: "List Item" }],
      },
      {
        action: "content_cut",
        title: "Office",
        items: [{ title: "List Item" }],
      },
      {
        action: "local_offer",
        title: "Promotions",
        items: [{ title: "List Item" }],
      },
    ],
  }),
  created() {
    var vm = this;
    vm.loading = true;
    eventBus.$on("getChangesBilling", function (value) {
      vm.changesBilling = value.show;
      vm.billing = value.value;
      vm.loading = false;
      // this.loading = false
    });
  },
};
</script>
